import type { ComponentType } from 'react';
import CustomerFeedback from '@/assets/imgs/crm.png';
import Employee from '@/assets/imgs/hrm.png';
import Clinico from '@/assets/imgs/Clinco.png';
import rent from '@/assets/imgs/businessAnalytics.png';
import Maintance from '@/assets/imgs/isometric _gear.png';
import FinancialManagement from '@/assets/svg/products/Financial';

// const ELECTRIC_CAR_PRODUCT_ID = '1';

export type ProductCardConfig = {
    id: string;
    path: (localizedPath: (path: string) => string) => string;
    titleKey: string;
    descriptionKey: string;
    Icon: string | ComponentType;
    readMore?: boolean;
};

export const topRowProductCards: ProductCardConfig[] = [
    {
        id: 'crm',
        path: (localizedPath) => localizedPath(`/crm`),
        titleKey: 'products.1.title',
        descriptionKey: 'home.products.crmDescription',
        Icon: CustomerFeedback,
    },
    {
        id: 'hrMangement',
        path: (localizedPath) => localizedPath('/hr-management'),
        titleKey: 'hrMangementPage.mainTitle',
        descriptionKey: 'home.products.hrDescription',
        Icon: Employee,
    },
    {
        id: 'financialManagement',
        path: (localizedPath) => localizedPath('/financial-management'),
        titleKey: 'financialManagementPage.mainTitle',
        descriptionKey: 'financialManagementPage.mainDesc',
        Icon: FinancialManagement,
    },
    {
        id: 'clinico',
        path: (localizedPath) => localizedPath('/clinico'),
        titleKey: 'clinicoPage.mainTitle',
        descriptionKey: 'clinicoPage.mainDesc',
        Icon: Clinico,
    },
    {
        id: 'fleet',
        path: (localizedPath) => localizedPath('/products/3'),
        titleKey: 'products.3.title',
        descriptionKey: 'products.3.cardDescription',
        Icon: rent,
    },
    {
        id: 'maintenance',
        path: (localizedPath) => localizedPath('/products/6'),
        titleKey: 'products.6.title',
        descriptionKey: 'products.3.cardDescription',
        Icon: Maintance,
        // readMore: true,
    },
];

